import { render, staticRenderFns } from "./UpdateEmail.vue?vue&type=template&id=18ad99df&scoped=true&"
import script from "./UpdateEmail.vue?vue&type=script&lang=ts&"
export * from "./UpdateEmail.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateEmail.vue?vue&type=style&index=0&id=18ad99df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ad99df",
  null
  
)

export default component.exports